import Filter from './filter';

export default Filter((FILTER_TYPES) => ({
  id: 'HALFBOARD',
  analyticsName: 'Half board',
  queryKey: 'f_halfBoard',
  type: FILTER_TYPES.BOOLEAN,
  bucketify: (hotel) => {
    const boardCode = hotel?.boardCode;
    // H, HW, HD, HL

    if (boardCode === 'H' || boardCode === 'HW' || boardCode === 'HD' || boardCode === 'HL') {
      return {
        bucketId: FILTER_TYPES.BINARY_BUCKET.TRUE,
        bucketName: 'halfBoard',
      };
    }

    return {
      bucketId: FILTER_TYPES.BINARY_BUCKET.FALSE,
      bucketName: 'halfBoard',
    };
  },
  toQuery: ({ value }) => {
    return value ? 1 : undefined;
  },
  fromQuery: (rawQueryValue) => {
    return {
      [FILTER_TYPES.BINARY_BUCKET.TRUE]: !!rawQueryValue,
    };
  },
}));
